define('SuiteDynamics.PDPChanges.GlobalChanges',
	[
		'underscore',
		'jQuery',
		'ProductDetails.Full.View'
	],
	function (
		_,
		jQuery,
		ProductDetailsFullView
	)
{
	'use strict';

	ProductDetailsFullView.prototype.initialize = _.wrap(ProductDetailsFullView.prototype.initialize, function (fn) {
		fn.apply(this, _.toArray(arguments).slice(1));

		var layout = this.application.getLayout();
		layout.once('afterAppendView', function() {
			jQuery('html, body').addClass('isPDP');
			jQuery('.shopping-layout-breadcrumb').css('background', '#ECF3F6');
		});
	});

	ProductDetailsFullView.prototype.render = _.wrap(ProductDetailsFullView.prototype.render, function (fn) {
		fn.apply(this, _.toArray(arguments).slice(1));
		jQuery('html, body').addClass('isPDP');
		jQuery('.shopping-layout-breadcrumb').css('background', '#ECF3F6');
	});

	ProductDetailsFullView.prototype.destroy = _.wrap(ProductDetailsFullView.prototype.destroy, function (fn) {
		fn.apply(this, _.toArray(arguments).slice(1));
		jQuery('html, body').removeClass('isPDP');
		jQuery('.shopping-layout-breadcrumb').css('background', '');
	});

	return {
		mountToApp: function mountToApp (container) {

		}
	};
});
